export class Step4 {
    constructor() {}

    // intitule = 'stepper.form.mapa_in.step3';
    section1 = 'form.mapa_in.step4_section1';

    getdescription = 'form.mapa_in.getdescription';
    getquantite = 'form.mapa_in.getquantite';
    getdateexecution = 'form.mapa_in.getdateexecution';
    getdatelivraison = 'form.mapa_in.getdatelivraison';
    getmotclef = 'form.mapa_in.getmotclef_liste_avi_';
    getspan4 = 'form.mapa_in.getspan4';
    getunlot = 'form.mapa_in.getunlot';
    getplusieurslot = 'form.mapa_in.getplusieurslot';
    gettouslots = 'form.mapa_in.gettouslots';
    add = 'boutons.add';
    remove = 'boutons.remove';

    intitule = 'stepper.form.dive_in.step4';
    getmiseenconcurrence = 'form.dive_in.getmiseenconcurrence';
    getinfocomplementaires = 'form.dive_in.getinfocomplementaires';
    getnumlot = 'form.dive_in.getnumlot';

}
